'use client';

import { Fragment, ReactNode } from 'react';
import { Icon, Link } from '@theme/components';
import { ROUTES } from '@theme/routes';
import { useLocalization } from '@akinon/next/hooks';
import { cn } from '@theme/utils';
import { BreadcrumbResultType } from '@theme/types';

export interface BreadcrumbProps {
  breadcrumbList?: BreadcrumbResultType[];
  productLength?: number;
  className?: string;
  separator?: ReactNode;
  itemClassName?: string;
  activeClassName?: string;
}

export default function Breadcrumb(props: BreadcrumbProps) {
  const { t } = useLocalization();
  const {
    breadcrumbList = [],
    productLength,
    className,
    separator,
    itemClassName,
    activeClassName
  } = props;

  const list = [
    { url: ROUTES.HOME, text: t('common.breadcrumb.homepage') },
    ...(breadcrumbList
      ? breadcrumbList.map((breadcrumb) => ({
          url: breadcrumb.url,
          text: breadcrumb.label
        }))
      : [])
  ];

  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-2 text-xs md:text-sm leading-4 text-gray-1100',
        className
      )}
    >
      {list.map((item, index) => (
        <Fragment key={index}>
          <Link
            className={cn(
              index === list.length - 1
                ? cn(itemClassName, activeClassName ?? 'text-black font-medium')
                : cn('whitespace-nowrap', itemClassName)
            )}
            href={item?.url || '#'}
          >
            {item?.text}{' '}
            {productLength &&
              index === list?.length - 1 &&
              `(${productLength} ${t('common.list.product')})`}
          </Link>
          {index !== list.length - 1 &&
            (separator ?? (
              <Icon name="chevron-end" size={8} className="text-black" />
            ))}
        </Fragment>
      ))}
    </div>
  );
}
